/* eslint-disable @typescript-eslint/naming-convention */
import { Injectable } from '@angular/core';
import { CallbackBody } from '../../../../entity-services/interfaces/src/lib/users/interfaces/phone-number-otp.interface';

@Injectable({
  providedIn: 'root',
})
export class CallbackBodyBuilder {
  createOTPRequestBody(authId: string, otp: string): CallbackBody {
    return {
      authId,
      callbacks: [
        {
          type: 'PasswordCallback',
          output: [{ name: 'prompt', value: 'OTP' }],
          input: [{ name: 'IDToken1', value: otp }],
        },
        {
          type: 'ConfirmationCallback',
          output: [
            { name: 'prompt', value: '' },
            { name: 'messageType', value: 0 },
            { name: 'options', value: ['Submit', 'Resend'] },
            { name: 'optionType', value: -1 },
            { name: 'defaultOption', value: 1 },
          ],
          input: [{ name: 'IDToken2', value: 0 }],
        },
      ],
    };
  }

  createResendOtpRequestBody(authId: string): CallbackBody {
    return {
      authId,
      callbacks: [
        {
          type: 'PasswordCallback',
          output: [{ name: 'prompt', value: 'OTP' }],
          input: [{ name: 'IDToken1', value: '' }],
        },
        {
          type: 'ConfirmationCallback',
          output: [
            { name: 'prompt', value: '' },
            { name: 'messageType', value: 0 },
            { name: 'options', value: ['Submit', 'Resend'] },
            { name: 'optionType', value: 1 },
            { name: 'defaultOption', value: 1 },
          ],
          input: [{ name: 'IDToken2', value: 1 }],
        },
      ],
    };
  }

  // WSO2-specific methods for mobile number OTP verification
  createWSO2MobileOtpVerificationBody(
    authId: string,
    callbacks: any[],
    otp: string,
    action: 'submit' | 'resend'
  ): CallbackBody {
    return {
      authId,
      callbacks: callbacks.map(callback => {
        if (callback.type === 'PasswordCallback') {
          // For submit, include the OTP; for resend, leave empty
          return {
            ...callback,
            input: [{ name: 'IDToken1', value: action === 'submit' ? otp : '' }]
          };
        } else if (callback.type === 'ConfirmationCallback') {
          // For submit, use 0; for resend, use 1
          return {
            ...callback,
            input: [{ name: 'IDToken2', value: action === 'submit' ? 0 : 1 }]
          };
        }
        // Return any other callbacks unchanged
        return callback;
      })
    };
  }
}
